import React, {memo} from 'react';

import {Typography} from '@mui/material';

import {
  EMessageBubbleSizeVariant,
  EMessageBubbleTailVariant,
  EMessageBubbleToneVariant,
} from './enums/index';
import './styles';

interface MessageBubbleProps {
  text: string;
  className?: string;
  tailVariant?: EMessageBubbleTailVariant;
  sizeVariant?: EMessageBubbleSizeVariant;
  toneVariant?: EMessageBubbleToneVariant;
}

const MessageBubbleComponent = ({
  text,
  className,
  tailVariant = EMessageBubbleTailVariant.Triangle,
  sizeVariant = EMessageBubbleSizeVariant.Md,
  toneVariant = EMessageBubbleToneVariant.Elevated,
}: MessageBubbleProps) => {
  const bubbleClassName = [
    'message-bubble',
    `message-bubble--tail-${tailVariant}`,
    `message-bubble--size-${sizeVariant}`,
    `message-bubble--tone-${toneVariant}`,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return <Typography className={bubbleClassName}>{text}</Typography>;
};

export const MessageBubble = memo(MessageBubbleComponent);
